<wtf-dialogcontent [size]="'md'" class="sms-modal" [dialogTitle]="dialogTitle" (closeModal)="dialogRef.close()"
    [action]="action">
    <!-- Content -->

    <form name="smsForm" [formGroup]="smsForm" class="tax-type-form w-100-p " fxLayout="column" fxFlex>
        <div fxLayout="row" fxLayoutAlign="end center">
            <mat-label>{{ "*Campos Obligatorios" | translate }}</mat-label>
        </div>
        <mat-label>{{ "Nombre de la Campaña" | translate }}</mat-label>
        <mat-form-field appearance="outline" class="w-100-p">
            <input matInput name="name" formControlName="name" mat-maxlength="50" placeholder=""
                [readonly]="action === recordAction.View" required />
        </mat-form-field>
        <ng-container>
            <mat-label>{{ "Codigo Corto" | translate }}*</mat-label>
            <mat-form-field appearance="outline" class="w-100-p">
                <mat-select [compareWith]="compareFn" name="shortcode" formControlName="shortcode" placeholder=""
                    required>
                    <mat-option *ngFor="let shortCode of shortCodes" [value]="shortCode">{{
                        shortCode.operator.name + " - " + shortCode.value
                        }}</mat-option>
                </mat-select>
            </mat-form-field>
        </ng-container>
        <div class="section-container" class="mb-24">
            <section *ngIf="action != recordAction.View" class="example-section">
                <mat-radio-group class="radio-group">
                    <mat-radio-button (change)="radioGrupoChange($event)" [checked]="templateSelected" class="mr-24"
                        value="1">{{ "template" | translate }}</mat-radio-button>
                    <mat-radio-button (change)="radioGrupoChange($event)" [checked]="!templateSelected"
                        class="example-margin" value="2">{{ "Msisdn" | translate }}</mat-radio-button>
                </mat-radio-group>
            </section>
        </div>

        <section *ngIf="smsType != 'INSTANTANEO CSV'" class="example-section">
            <mat-label *ngIf="templateSelected">{{ "template" | translate }}*</mat-label>
            <mat-form-field appearance="outline" *ngIf="templateSelected" class="w-100-p">
                <mat-select [compareWith]="compareFn" (selectionChange)="onSelect($event)" name="template"
                    formControlName="template" placeholder="">
                    <mat-form-field>
                        <input #searchInput matInput placeholder="Search..." (keyup)="onKey($event.target)" />
                    </mat-form-field>
                    <mat-option *ngFor="let template of smsFilteredTemplates" [value]="template">{{
                        template.name
                        }}</mat-option>
                </mat-select>
            </mat-form-field>
            <mat-label *ngIf="templateSelected">{{ "Grupos" | translate }}*</mat-label>
            <mat-form-field appearance="outline" *ngIf="templateSelected" class="w-100-p">
                <mat-select [compareWith]="compareFn" name="grupo" formControlName="grupo" placeholder="" multiple>
                    <mat-option *ngFor="let grupo of grupos" [value]="grupo">{{
                        grupo.name
                        }}</mat-option>
                </mat-select>
            </mat-form-field>
            <mat-label *ngIf="!templateSelected">{{ "Para:" | translate }}*</mat-label>
            <mat-form-field appearance="outline" *ngIf="!templateSelected" class="w-100-p">
                <input matInput name="msisdn" formControlName="msisdn" mat-maxlength="50" placeholder=""
                    [readonly]="action === recordAction.View" />
            </mat-form-field>
        </section>

        <!--<mat-form-field class="w-100-p">
                <input matInput name="service_type" formControlName="service_type" mat-maxlength="50" placeholder="Identificador de Campaña" [readonly]="action===recordAction.View">
            </mat-form-field> -->
        <mat-label>{{ "Mensaje" | translate }}*</mat-label>
        <mat-form-field appearance="outline" class="">
            <textarea required matInput #input maxlength="150" name="message" [readonly]="action === recordAction.View"
                formControlName="message" placeholder=""></textarea>
        </mat-form-field>
        <mat-hint align="start">{{ input.value?.length || 0 }}/150
            {{ "caracteres" | translate }}</mat-hint>
        <mat-checkbox name="instantaneo" (change)="onChangeHideMessage($event)">{{
            "Ocultar" | translate
            }}</mat-checkbox>
        <mat-label>{{ "Periodo de Validez" | translate }} ({{ "Horas" | translate }})* </mat-label>
        <mat-form-field appearance="outline" class="w-100-p">
            <input required matInput #input type="number" name="message" [readonly]="action === recordAction.View"
                formControlName="validityPeriod" placeholder="" />
        </mat-form-field>

        <mat-checkbox name="instantaneo" [checked]="hasURL" [disabled]="templateSelected" (change)="hasUrl($event)">{{
            "Agregar URL" | translate
            }}</mat-checkbox>

        <div *ngIf="hasURL">
            <mat-label>{{ "URL" | translate }}*</mat-label>
            <mat-form-field appearance="outline" class="w-100-p">
                <input matInput #input maxlength="150" name="message" [readonly]="action === recordAction.View"
                    formControlName="longUrl" placeholder="" />
            </mat-form-field>
        </div>

        <div class="w-100-p h-100-p">
            <button class="w-100-p h-100-p" mat-raised-button [spinnerButton]="isWaiting" (click)="performAction()"
                class="save-button mb-3" [disabled]="smsForm.invalid" aria-label="Enviar">
                <span class="material-icons-outlined mr-24"> send </span>
                {{ "Enviar" | translate }}
            </button>
        </div>
    </form>
    <!-- Content -->

    <!-- Buttons -->

    <!-- Buttons -->
</wtf-dialogcontent>